import { render, staticRenderFns } from "./choose.vue?vue&type=template&id=032f1542&scoped=true&"
import script from "./choose.vue?vue&type=script&lang=js&"
export * from "./choose.vue?vue&type=script&lang=js&"
import style0 from "./choose.vue?vue&type=style&index=0&id=032f1542&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032f1542",
  null
  
)

export default component.exports